import axios from 'axios';
import { Component } from 'react'
import { FormControl, OverlayTrigger, Popover, Spinner, Tab, Tabs } from 'react-bootstrap';
import { connect } from 'react-redux';
import ClipboardIcon from '../../../components/common/ClipboardIcon';
import type { AppState } from '../../../store';
import AxiosConfig from '../../../utilities/AxiosConfig';
import { shouldAllowAccess } from '../../../utilities/helper';
import VehicleAttachments from './Attachments/VehicleAttachments';
import VehicleDetails from './Details/VehicleDetails';
import VehicleFuelReceipts from './FuelReceipts/VehicleFuelReceipts';
import VehicleInspections from './Inspections/VehicleInspections';
import VehicleMaintenance from './Maintenance/VehicleMaintenance';
import VehicleNotes from './Notes/VehicleNotes';
import './Overview.css'
import VehicleLeaseInformation from './LeaseInformation/VehicleLeaseInformation';

interface OverviewProps {
    details: any
    userId: any
    fleetReference: any
    activeKey: string
    setActiveKey: Function
    sideMenuOpen: boolean
    features: { [key: string]: boolean }
}

type OverviewTypes = {
    previewPhoto: string
    loadingPreview: boolean
    inspectionWarning: boolean
    maintenanceWarning: boolean
    maintenanceReviewWarning: boolean,
    inspections: Array<any>
    maintenances: Array<any>
    overdueMaintenancesList: Array<any>
    servicesPerformed: Array<any>
    receipts: Array<any>
    leases: Array<any>
    leasesLoading: boolean
    info: any
    inspectionPics: Array<any>
    comparisonPics: Array<any>
    currentInspection: number
    currentComparison: number
    showLinkPopover: boolean
    notes: Array<any>
    attachments: Array<any>
    profitCenterDescription: string
    vehicleStatusDescription: string
}

class Overview extends Component<OverviewProps, OverviewTypes> {
    preRenderInterval: any
    renderCount: number = 0
    preRenderState: any = {
        previewPhoto: "",
        loadingPreview: true,
        inspectionWarning: false,
        maintenanceWarning: false,
        maintenanceReviewWarning: false,
        inspections: [],
        maintenances: [],
        overdueMaintenancesList: [],
        servicesPerformed: [],
        receipts: [],
        info: {},
        inspectionPics: [],
        comparisonPics: [],
        currentInspection: 0,
        currentComparison: 0,
        showLinkPopover: false,
        notes: [],
        attachments: [],
        leases: [],
        leasesLoading: true,
        profitCenterDescription: "",
        vehicleStatusDescription: ""
    }

    constructor(props: any) {
        super(props)
        this.state = {
            previewPhoto: "",
            loadingPreview: false,
            inspectionWarning: false,
            maintenanceWarning: false,
            maintenanceReviewWarning: false,
            inspections: [],
            maintenances: [],
            overdueMaintenancesList: [],
            servicesPerformed: [],
            receipts: [],
            info: {},
            inspectionPics: [],
            comparisonPics: [],
            currentInspection: 0,
            currentComparison: 0,
            showLinkPopover: false,
            notes: [],
            attachments: [],
            leases: [],
            leasesLoading: true,
            profitCenterDescription: "",
            vehicleStatusDescription: ""
        }
    }

    componentDidMount() {
        this.getVehicleInspections()
        this.getVehicleMaintenance()
        this.check4OverdueMaintenance()
        this.getFuelReceipts()
        this.getVehicleInfo()
        this.getNotes()
        this.getAttachments()
        this.getLeases()
        this.preRenderInterval = setInterval(this.listen4Render, 500)

    }

    componentWillUnmount() {
        clearInterval(this.preRenderInterval)
    }

    listen4Render = () => {
        if (JSON.stringify(this.state) !== JSON.stringify(this.preRenderState)) {
            this.renderCount = this.renderCount + 1
            this.setState(this.preRenderState)
        }
    }

    refreshAll = (option?: string) => {
        if (option === "inspections") {
            this.getVehicleInspections()
        }
        if (option === "maintenance") {
            this.getVehicleMaintenance()
            this.check4OverdueMaintenance()
        }
        if (option === "receipts") {
            this.getFuelReceipts()
        }
        if (option === "details") {
            this.getVehicleInfo()
        }
        if (option === "notes") {
            this.getNotes()
        }
        if (option === "attachments") {
            this.getAttachments()
        }
        if (option === "leases") {
            this.getLeases()
        }
        if (!option) {
            this.getVehicleInspections()
            this.getVehicleMaintenance()
            this.check4OverdueMaintenance()
            this.getFuelReceipts()
            this.getVehicleInfo()
            this.getNotes()
            this.getAttachments()
        }
    }

    handleSelect = (key: any) => {
        this.props.setActiveKey(key)
    }

    getVehicleInspections = () => {
        axios.get(`${process.env.REACT_APP_API_URL}/api/Fleet/getInspectionsByVehicleId/${this.props.details.VehicleInformationId}`, AxiosConfig.configValue())
            .then(res => {
                const inspections = res.data.inspections
                let unreviewed = 0
                for (let i = 0; i < inspections.length; i++) {
                    if (inspections[i].ReviewedBy === "") {
                        unreviewed += 1
                    }
                }
                if (unreviewed > 0) {
                    this.preRenderState.inspectionWarning = true
                } else {
                    this.preRenderState.inspectionWarning = false
                }
                this.preRenderState.inspections = inspections.reverse()
                this.openInspection(inspections[this.state.currentInspection].vehicleInspectionId, this.state.currentInspection)
            }).catch(err => {
                this.preRenderState.loadingPreview = false
                //console.log(err, err.response);
                AxiosConfig.handleError(err);
            })
    }

    getVehicleMaintenance = () => {
        axios.get(`${process.env.REACT_APP_API_URL}/api/Fleet/getMaintenancesByVehicleId/${this.props.details.VehicleInformationId}`, AxiosConfig.configValue())
            .then(res => {
                const maintenances = res.data.sort((a: any, b: any) => (a.Mileage < b.Mileage) ? 1 : -1)
                this.preRenderState.maintenances = maintenances
                const warningIcon = document.getElementById(`${this.props.details.VehicleNumber}-maintenance-wating-review`)
                const shouldClear = this.clearMaintenanceInspectionWarning(maintenances)
                this.preRenderState.maintenanceReviewWarning = !shouldClear
                if (shouldClear && warningIcon) {
                    warningIcon.style.display = "none"
                }
            }).catch(err => {
                //console.log(err, err.response);
                AxiosConfig.handleError(err);
            })
    }

    clearMaintenanceInspectionWarning = (maintenances: Array<any>) => {
        const temp = []
        for (let i = 0; i < maintenances.length; i++) {
            if (maintenances[i].ReviewStatusTypeId !== 2 && maintenances[i].ReviewStatusTypeId !== 3) {
                temp.push(maintenances[i].VehicleMaintenanceId)
            }
            // //console.log(maintenances[i].ReviewStatusTypeId)
        }
        if (temp.length > 0) {
            return false
        }
        return true
    }

    check4OverdueMaintenance = () => {
        axios.get(`${process.env.REACT_APP_API_URL}/api/Fleet/getPastDueMaintenancesByVehicleId/${this.props.details.VehicleInformationId}`, AxiosConfig.configValue())
            .then(res => {
                this.preRenderState.overdueMaintenancesList = res.data
                if (res.data.length === 0) {
                    const overdueIcon = document.getElementById(`${this.props.details.VehicleNumber}-maintenance-overdue`)
                    if (overdueIcon) {
                        overdueIcon.style.display = "none"
                    }
                    this.preRenderState.maintenanceWarning = false
                } else {
                    this.preRenderState.maintenanceWarning = true
                }
            }).catch(err => {
                //console.log(err, err.response);
                AxiosConfig.handleError(err);
            })
    }

    getVehicleInfo = () => {
        axios.get(`${process.env.REACT_APP_API_URL}/api/Fleet/getVehicleByVehicleInformationId/${this.props.details.VehicleInformationId}`, AxiosConfig.configValue())
            .then(res => {
                this.preRenderState.info = res.data
                this.getProfitCenterDescription(res.data)
                this.getVehicleStatusDescription(res.data)
            }).catch(err => {
                //console.log(err, err.response);
                AxiosConfig.handleError(err);
            })
    }

    getProfitCenterDescription = (data: any) => {
        if (this.props.fleetReference.profitCenters.length > 0) {
            for (let i = 0; i < this.props.fleetReference.profitCenters.length; i++) {
                if (data.ProfitCenterId === this.props.fleetReference.profitCenters[i].id) {
                    this.preRenderState.profitCenterDescription = this.props.fleetReference.profitCenters[i].text
                }
            }
        }
    }

    getVehicleStatusDescription = (data: any) => {
        if (this.props.fleetReference.vehicleStatusTypes.length > 0) {
            for (let i = 0; i < this.props.fleetReference.vehicleStatusTypes.length; i++) {
                if (data.VehicleStatusTypeId === this.props.fleetReference.vehicleStatusTypes[i].id) {
                    this.preRenderState.vehicleStatusDescription = this.props.fleetReference.vehicleStatusTypes[i].text
                }
            }
        }
    }

    getFuelReceipts = () => {
        axios.get(`${process.env.REACT_APP_API_URL}/api/Fleet/getFuelReceiptsByVehicleId/${this.props.details.VehicleInformationId}`, AxiosConfig.configValue())
            .then(res => {
                this.preRenderState.receipts = res.data.fuelReceipts.reverse()
            }).catch(_err => {
                //console.log(err)
            })
    }

    getNotes = () => {
        axios.get(`${process.env.REACT_APP_API_URL}/api/Fleet/getNotesByVehicleInformationId/${this.props.details.VehicleInformationId}`, AxiosConfig.configValue())
            .then(res => {
                this.preRenderState.notes = res.data.reverse()
            }).catch(_err => {
                //console.log(err)
            })
    }

    getAttachments = () => {
        axios.get(`${process.env.REACT_APP_API_URL}/api/Fleet/getVehicleAttachmentsByVehicleId/${this.props.details.VehicleInformationId}`, AxiosConfig.configValue())
            .then(res => {
                this.preRenderState.attachments = res.data
            }).catch(err => {
                //console.log(err, err.response);
                AxiosConfig.handleError(err);
            })
    }

    getLeases = () => {
        this.preRenderState.leasesLoading = true
        axios.get(`${process.env.REACT_APP_API_URL}/api/fleet/leases/vehicle/${this.props.details.VehicleInformationId}`, AxiosConfig.configValue())
            .then(res => {
                this.preRenderState.leases = res.data
                this.preRenderState.leasesLoading = false
            }).catch(err => {
                this.preRenderState.leasesLoading = false
                AxiosConfig.handleError(err);
            })
    }

    openComparison = (inspectionId: string, currentComparison: number) => {
        this.preRenderState.comparisonPics = []
        axios.get(`${process.env.REACT_APP_API_URL}/api/Fleet/getInspectionImages/${inspectionId}`, AxiosConfig.configValue())
            .then(res => {
                this.buildComparisonPhotoArray(res.data.inspectionImages)
                this.preRenderState.currentComparison = currentComparison
            }).catch(err => {
                //console.log(err, err.response);
                AxiosConfig.handleError(err);
            })
    }

    openInspection = (inspectionId: string, currentInspection: number) => {
        this.preRenderState.inspectionPics = []
        this.preRenderState.loadingPreview = true
        axios.get(`${process.env.REACT_APP_API_URL}/api/Fleet/getInspectionImages/${inspectionId}`, AxiosConfig.configValue())
            .then(res => {
                this.buildInspectionPhotoArray(res.data.inspectionImages)
                this.preRenderState.currentInspection = currentInspection
                this.preRenderState.previewPhoto = res.data.inspectionImages[2].imageFullUrl
                if (res.data.inspectionImages.length > 0) {
                    for (let i = 0; i < res.data.inspectionImages.length; i++) {
                        const str = res.data.inspectionImages[i].name.split("_")
                        if (str[1].trim() === "ExteriorDriverFront") {
                            this.preRenderState.previewPhoto = res.data.inspectionImages[i].imageFullUrl
                        }
                    }
                }
                this.preRenderState.loadingPreview = false
            }).catch(err => {
                this.preRenderState.previewPhoto = "none"
                this.preRenderState.loadingPreview = false
                //console.log(err, err.response);
                AxiosConfig.handleError(err);
            })
    }

    buildInspectionPhotoArray = (pics: Array<any>) => {
        const picsArray: Array<any> = []
        for (let i = 0; i < pics.length; i++) {
            const temp: any = {}
            temp.img = pics[i].imageFullUrl
            const splitter: Array<string> = pics[i].name.split("_")
            temp.name = splitter[1]
            temp.date = pics[i].option2 ? pics[i].option2 : "NA"
            temp.offset = pics[i].option1 ? pics[i].option1 : 0
            picsArray.push(temp)
        }
        this.preRenderState.inspectionPics = picsArray
    }

    buildComparisonPhotoArray = (pics: Array<any>) => {
        const picsArray: Array<any> = []
        for (let i = 0; i < pics.length; i++) {
            const temp: any = {}
            temp.img = pics[i].imageFullUrl
            const splitter: Array<string> = pics[i].name.split("_")
            temp.name = splitter[1]
            temp.date = pics[i].option2 ? pics[i].option2 : "NA"
            temp.offset = pics[i].option1 ? pics[i].option1 : 0
            picsArray.push(temp)
        }
        this.preRenderState.comparisonPics = picsArray
    }

    setInspectionWarning = (warning: boolean) => {
        this.preRenderState.inspectionWarning = warning
    }

    generateShareLink = () => {
        navigator.clipboard.writeText(`${window.location.href}/?&VehicleNumber=${this.props.details.VehicleNumber}`)
        this.toggleLinkPopover()
    }

    toggleLinkPopover = () => {
        if (this.state.showLinkPopover) {
            this.setState({ showLinkPopover: false })
            this.preRenderState.showLinkPopover = false
        } else {
            this.setState({ showLinkPopover: true })
            this.preRenderState.showLinkPopover = true
        }
    }

    selectLinkText = () => {
        const element: any = document.getElementById("share-link-popover-form")
        if (element) {
            element.focus()
            element.select()
        }
    }

    render() {

        // //console.log("props: ", this.props)
        // //console.log("state: ", this.state)

        const shareLinkPopover = (
            <Popover id="popover-basic">
                <Popover.Title as="h3">Link has been copied to clipboard.</Popover.Title>
                <FormControl id="share-link-popover-form"
                    placeholder={`${window.location.href}/?&VehicleNumber=${this.props.details.VehicleNumber}`}
                    aria-describedby="basic-addon1"
                    disabled={false}
                    value={`${window.location.href}/?&VehicleNumber=${this.props.details.VehicleNumber}`}
                    onChange={() => this.selectLinkText()}
                    onClick={() => this.selectLinkText()}
                />
                <Popover.Content>
                    Paste this link into an email or text message to share this vehicle detail with another Portal user.
                </Popover.Content>
                <p id="share-vehicle-url-dismiss-btn" onClick={() => this.toggleLinkPopover()}>Close</p>
            </Popover>
        )

        const overdueMaintenancesPopover = (
            <Popover id="popover-basic">
                <Popover.Title as="h3">The following maintenance items are overdue for this vehicle.</Popover.Title>
                <Popover.Content>
                    {this.state.overdueMaintenancesList.map((overdueItem: any, i: number) =>
                        <div className="Overdue-Maintenance-Popover-Item-Wrapper" key={`overdue-maintenance-item-${i}`}>
                            <p id="overdue-maintenance-item-description">{overdueItem.VehicleMaintenanceTypeDesc} was due at {overdueItem.NextServiceDue.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")} miles.</p>
                            <p id="overdue-maintenance-item-range"> (<span>{(overdueItem.MileageSinceService - overdueItem.ScheduledMileage).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</span> miles overdue)</p>
                        </div>
                    )}
                </Popover.Content>
            </Popover>
        )

        return (
            <div className="Overview">
                <div className="Fleet-Overview-Header-Panels">
                    <div className="Fleet-Overview-LP">
                        {this.state.overdueMaintenancesList.length > 0 && <OverlayTrigger trigger={["hover", "focus"]} placement="right" delay={0} overlay={overdueMaintenancesPopover}>
                            <div className="Overdue-Maintenance-Wrapper">
                                <span className="material-icons">assignment_late</span>
                            </div>
                        </OverlayTrigger>}
                        {!this.state.info.VehicleNumber && <Spinner id="loading-vehicle-info" animation="border" />}
                        {this.state.info.VehicleNumber && <div>
                            <h1>{this.state.info.VehicleNumber}</h1>
                            <p>{`${this.state.info.Year} ${this.state.info.Make} ${this.state.info.Model}`}</p>
                            <p>{this.state.profitCenterDescription}</p>
                            <div className="Fleet-Overview-LP-Footer">
                                <div className="Fleet-Overview-LP-Footer-Vin"><p id="Fleet-Overview-LP-footer-l">VIN:</p><p id="Fleet-Overview-LP-footer-r">{this.state.info.VinNumber}</p>
                                    <ClipboardIcon
                                        text={this.state.info.VinNumber}
                                    />
                                </div>
                                <div className="Fleet-Overview-LP-Footer-Odo"><p id="Fleet-Overview-LP-footer-l">ODOMETER:</p><p id="Fleet-Overview-LP-footer-r">{this.props.details.Mileage.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</p></div>
                                {this.state.info.License && <div className="Fleet-Overview-LP-Footer-Lease"><p id="Fleet-Overview-LP-footer-l">LICENSE PLATE:</p><p id="Fleet-Overview-LP-footer-r">{this.state.info.License}</p></div>}
                                {this.state.info.VehicleNumber && !this.state.info.License && <div className="Fleet-Overview-LP-Footer-Lease"><p id="Fleet-Overview-LP-footer-l">LICENSE PLATE:</p><p id="Fleet-Overview-LP-footer-r">*NA*</p></div>}
                                {!this.state.info.VehicleNumber && <div className="Fleet-Overview-LP-Footer-Lease"><p id="Fleet-Overview-LP-footer-l">LICENSE PLATE:</p><Spinner id="Fleet-Overview-LP-footer-loading-license-spinner" animation="border" /></div>}
                            </div>
                        </div>}
                    </div>
                    <div className="Fleet-Overview-RP">
                        <div className="Vehicle-Detail-Panel-LastDriver-And-Status">
                            <p id="vsdrp-rp-last-driver-header">LastDriver</p>
                            {this.props.details.LastDriver.length > 0 && <p id="vsdrp-rp-last-driver-data">{this.props.details.LastDriver}</p>}
                            {this.props.details.LastDriver.length === 0 && <p id="vsdrp-rp-last-driver-data">Unknown</p>}
                            <p id="vsdrp-rp-status-header">Status</p>
                            {this.state.vehicleStatusDescription.length > 0 && <p id="vsdrp-rp-status-data">{this.state.vehicleStatusDescription}</p>}
                            {this.state.vehicleStatusDescription.length === 0 && <p id="vsdrp-rp-status-data">Unknown</p>}
                            <div id="share-vehicle-url-button-wrapper">
                                <span id="share-vehicle-url-button" className="material-icons" onClick={() => this.generateShareLink()}>share</span>
                                <p id="share-vehicle-url-button-descriptor" onClick={() => this.generateShareLink()}>Link to Vehicle</p>
                            </div>
                            {this.state.showLinkPopover && <OverlayTrigger show={true} placement="bottom" overlay={shareLinkPopover}><div id="share-vehicle-url-popover"></div></OverlayTrigger>}
                        </div>
                        <div className="VI-Main-Pic">
                            {this.state.inspectionPics.length > 0 && <img src={this.state.previewPhoto} alt=""></img>}
                            {this.state.inspectionPics.length === 0 && <span className="material-icons">image_not_supported</span>}
                        </div>
                    </div>
                </div>
                <div className={"Fleet-Overview-Tabs"}>
                    <Tabs defaultActiveKey={this.props.activeKey} variant={"pills"} id="Fleet-Overview-Tabs" onSelect={this.handleSelect}>
                        <Tab eventKey="Details" title={<div id="overview-no-warning">Details</div>} unmountOnExit={true}>
                            <VehicleDetails
                                details={this.props.details}
                                info={this.state.info}
                                fleetReference={this.props.fleetReference}
                                userId={this.props.userId}
                                refreshAll={this.refreshAll}
                            />
                        </Tab>
                        {this.state.inspectionWarning && <Tab eventKey="Inspections" title={<div id="overview-inspection-warning">Inspections <p>{` (${this.state.inspections.length})`}</p><span className="material-icons">priority_high</span></div>} unmountOnExit={true} >
                            <VehicleInspections
                                details={this.props.details}
                                inspections={this.state.inspections}
                                inspectionPics={this.state.inspectionPics}
                                comparisonPics={this.state.comparisonPics}
                                currentInspection={this.state.currentInspection}
                                currentComparison={this.state.currentComparison}
                                getVehicleInfo={this.getVehicleInspections}
                                setWarning={this.setInspectionWarning}
                                openInspection={this.openInspection}
                                openComparison={this.openComparison}
                                sideMenuOpen={this.props.sideMenuOpen}
                                refreshAll={this.refreshAll}
                                showLinkPopover={this.state.showLinkPopover}
                            />
                        </Tab>}
                        {!this.state.inspectionWarning && <Tab eventKey="Inspections" title={<div id="overview-no-warning">Inspections <p>{` (${this.state.inspections.length})`}</p></div>} unmountOnExit={true}>
                            <VehicleInspections
                                details={this.props.details}
                                inspections={this.state.inspections}
                                inspectionPics={this.state.inspectionPics}
                                comparisonPics={this.state.comparisonPics}
                                currentInspection={this.state.currentInspection}
                                currentComparison={this.state.currentComparison}
                                getVehicleInfo={this.getVehicleInspections}
                                setWarning={this.setInspectionWarning}
                                openInspection={this.openInspection}
                                openComparison={this.openComparison}
                                sideMenuOpen={this.props.sideMenuOpen}
                                refreshAll={this.refreshAll}
                                showLinkPopover={this.state.showLinkPopover}
                            />
                        </Tab>}
                        {this.state.maintenanceWarning && !this.state.maintenanceReviewWarning && <Tab eventKey="Maintenance" title={<div id="overview-maintenance-warning">Maintenance <p>{` (${this.state.maintenances.length})`}</p><span className="material-icons">query_builder</span></div>} unmountOnExit={true} >
                            <VehicleMaintenance
                                details={this.props.details}
                                maintenances={this.state.maintenances}
                                fleetReference={this.props.fleetReference}
                                userId={this.props.userId}
                                refreshAll={this.refreshAll}
                            />
                        </Tab>}
                        {!this.state.maintenanceWarning && this.state.maintenanceReviewWarning && <Tab eventKey="Maintenance" title={<div id="overview-maintenance-review-warning">Maintenance <p>{` (${this.state.maintenances.length})`}</p><span className="material-icons">build</span></div>} unmountOnExit={true} >
                            <VehicleMaintenance
                                details={this.props.details}
                                maintenances={this.state.maintenances}
                                fleetReference={this.props.fleetReference}
                                userId={this.props.userId}
                                refreshAll={this.refreshAll}
                            />
                        </Tab>}
                        {!this.state.maintenanceWarning && !this.state.maintenanceReviewWarning && <Tab eventKey="Maintenance" title={<div id="overview-no-warning">Maintenance <p>{` (${this.state.maintenances.length})`}</p></div>} unmountOnExit={true}>
                            <VehicleMaintenance
                                details={this.props.details}
                                maintenances={this.state.maintenances}
                                fleetReference={this.props.fleetReference}
                                userId={this.props.userId}
                                refreshAll={this.refreshAll}
                            />
                        </Tab>}
                        {this.state.maintenanceWarning && this.state.maintenanceReviewWarning && <Tab eventKey="Maintenance" title={<div id="overview-maintenance-and-review-warning">Maintenance <p>{` (${this.state.maintenances.length})`}</p><span id="overview-maintenance-and-review-warning-left" className="material-icons">query_builder</span><span id="overview-maintenance-and-review-warning-right" className="material-icons">build</span></div>} unmountOnExit={true} >
                            <VehicleMaintenance
                                details={this.props.details}
                                maintenances={this.state.maintenances}
                                fleetReference={this.props.fleetReference}
                                userId={this.props.userId}
                                refreshAll={this.refreshAll}
                            />
                        </Tab>}
                        <Tab eventKey="Notes" title={<div id="overview-no-warning">Notes <p>{` (${this.state.notes.length})`}</p></div>} unmountOnExit={true} >
                            <VehicleNotes
                                notes={this.state.notes}
                                refreshAll={this.refreshAll}
                                userId={this.props.userId}
                                info={this.state.info}
                            />
                        </Tab>
                        <Tab eventKey="Attachments" title={<div id="overview-no-warning">Attachments <p>{` (${this.state.attachments.length})`}</p></div>} unmountOnExit={true} >
                            <VehicleAttachments
                                details={this.props.details}
                                userId={this.props.userId}
                                refreshAll={this.refreshAll}
                                attachments={this.state.attachments}
                            />
                        </Tab>
                        <Tab eventKey="FuelReiceipts" title={<div id="overview-no-warning">Fuel Receipts <p>{` (${this.state.receipts.length})`}</p></div>} unmountOnExit={true}>
                            <VehicleFuelReceipts
                                details={this.props.details}
                                receipts={this.state.receipts}
                            />
                        </Tab>
                        {this.props.features?.LeaseTracker && shouldAllowAccess("FLEET:LEASEUSER") && (
                            <Tab eventKey="LeaseInformation" title={<div id="overview-no-warning">Lease Information <p>{` (${this.state.leases.length})`}</p></div>} unmountOnExit={true}>
                            <VehicleLeaseInformation
                                leases={this.state.leases}
                                leasesLoading={this.state.leasesLoading}
                                info={this.state.info}
                                userId={this.props.userId}
                                refreshAll={this.refreshAll}
                            />
                        </Tab>
                        )}
                        
                    </Tabs>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state: AppState) => ({
    userId: state.user.userId,
    sideMenuOpen: state.menu.sideMenuOpen,
    features: state.features
})

export default connect(mapStateToProps)(Overview)